import styled, { css } from "styled-components";
import { getAppearFromLeft } from "theme/animations";

interface ContainerProps {
  isVisible: boolean;
}

interface SquareProps {
  color: string;
}

const SQUARE_SIZE = "1.6em";

export const Container = styled.div<ContainerProps>`
  display: flex;

  #marked-text-square,
  #marked-text-text {
    opacity: 0;
  }

  ${({ isVisible }) =>
    isVisible
      ? css`
          #marked-text-square {
            animation: ${getAppearFromLeft()} 1s;
            animation-fill-mode: both;
            animation-delay: 1.5s;
          }

          #marked-text-text {
            animation: ${getAppearFromLeft("-20%")} 1s;
            animation-fill-mode: both;
            animation-delay: 2s;
          }
        `
      : ""}
`;

export const Square = styled.div<SquareProps>`
  z-index: 1;
  min-width: ${SQUARE_SIZE};
  height: ${SQUARE_SIZE};
  margin-right: 15px;
  background-color: ${({ color }) => color};
`;
